module.exports = __webpack_public_path__ + "img/12-1.199aa0ec.png";